import { SimpleGrid, Button, Box, Flex } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import BoxIcon from '@/public/assets/icons/box.svg'
import InventoryIcon from '@/public/assets/icons/inventory.svg'
import { RulesButton } from '@/components/atoms/RulesButton/RulesButton'
import { GameRules } from 'types/types'
import { useTranslation } from 'next-i18next/pages'

export const LootboxNavigation = () => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <Flex alignItems={'center'} justifyContent={'space-between'} mb={6} gap={2}>
      <SimpleGrid p={1} gap={1} rounded={'xl'} bg={'ninja.600'} columns={2} flexBasis={'full'} maxW={'350px'}>
        <Button
          onClick={() => router.push('/lootbox')}
          h={10}
          color={router.pathname === '/lootbox' ? 'white' : 'ninja.300'}
          bg={router.pathname === '/lootbox' ? 'ninja.900' : 'transparent'}
          _hover={{
            bg: 'ninja.900',
            color: 'white',
          }}
          rounded={'xl'}
          variant={'unstyled'}
          display={'flex'}
          gap={2}
          fontSize={{ base: 'xs', md: 'sm' }}
        >
          <Box display={{ base: 'none', md: 'block' }}>
            <BoxIcon />
          </Box>
          {t('common.collections')}
        </Button>
        <Button
          onClick={() => router.push('/lootbox/inventory')}
          color={router.pathname === '/lootbox/inventory' ? 'white' : 'ninja.300'}
          bg={router.pathname === '/lootbox/inventory' ? 'ninja.900' : 'transparent'}
          h={10}
          _hover={{
            bg: 'ninja.900',
            color: 'white',
          }}
          rounded={'xl'}
          variant={'unstyled'}
          display={'flex'}
          gap={2}
          fontSize={{ base: 'xs', md: 'sm' }}
        >
          <Box display={{ base: 'none', md: 'block' }}>
            <InventoryIcon />
          </Box>
          {t('common.inventory')}
        </Button>
      </SimpleGrid>
      <RulesButton styles={{ flexShrink: 0 }} compact={true} game={GameRules.LOOTBOX} />
    </Flex>
  )
}
